export function applyOptimisticStage(currentData, { stage, changedBy, now = new Date() }) {
  if (!currentData?.applicant || !stage) return currentData;

  const createdAt = now instanceof Date ? now.toISOString() : new Date(now).toISOString();
  const previousStage = currentData.applicant.stage;

  return {
    ...currentData,
    applicant: {
      ...currentData.applicant,
      stage,
      updated_at: createdAt,
    },
    stageHistory: [
      ...(currentData.stageHistory || []),
      {
        from_stage: previousStage,
        to_stage: stage,
        changed_by: changedBy || 'Current user',
        created_at: createdAt,
        optimistic: true,
      },
    ],
  };
}

export function rollbackOptimisticStage({ previous }) {
  return previous;
}
